import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/modal-title.module.css';

function ModalTitle({ tag = 'h4', className = null, ...props }: TypographyProps) {
    return (
        <Typography tag={tag} className={classNames([styles.container, className])} {...props} />
    );
}

export default ModalTitle;
